import { CampaignVenues } from './CampaignVenues';

export class CampaignVenuesPartner extends CampaignVenues {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/CampaignVenuesPartner.js